module.exports = __webpack_public_path__ + "static/media/hipercard.d20a0803.svg";